export default "__VITE_ASSET__f6ac340c__"